import React from 'react'
import PropTypes from 'prop-types'
import { ErrorBoundary } from '@sainsburys-tech/bolt'

import Breadcrumb from '../../components/Breadcrumbs/Breadcrumb'
import { Breadcrumb as FableBreadcrumb } from '@/components/Breadcrumb/Breadcrumb'

const BreadCrumbSection = ({ className, breadcrumbOptions, PDP_V2_FLAG }) => {
  return (
    <section className={className}>
      <ErrorBoundary>
        {PDP_V2_FLAG ? <FableBreadcrumb {...breadcrumbOptions} /> : <Breadcrumb {...breadcrumbOptions} />}
      </ErrorBoundary>
    </section>
  )
}

BreadCrumbSection.propTypes = {
  className: PropTypes.string.isRequired,
  breadcrumbOptions: PropTypes.object.isRequired,
  PDP_V2_FLAG: PropTypes.bool.isRequired
}

export default BreadCrumbSection
